import { useEffect, useState } from "react";
import { Divider, Grid, Stack, Typography } from "@mui/material";
import { BtnExportExcel } from "components/Button/ButtonAll";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import { FormProvider, useForm } from "react-hook-form";
import { FnAxios, FnDialog, I18n } from "utilities/utilities";
import { SelectItem } from "components/Input/Select/SelectItem";
import moment from "moment";

const ReportTicketFund = () => {
    const DialogFn = FnDialog();
    const AxiosFn = FnAxios();

    const formTicket = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });


    const [arrMuseum, setarrMuseum] = useState<any>([]);

    const [isPermission, setPermission] = useState<boolean>(true); // Permission
    useEffect(() => {
        getFormInitial();
        setPermission(true)
        // GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const getFormInitial = () => {
        AxiosFn.Get(`ReportTicketFund/GetFormInitial`, {}, (result) => {
            setarrMuseum(result.lstDataMuseum);
            formTicket.setValue("nMuseumID",result.nMuseumID)
        })
    }

    const handleExportExcelTicket = () => {
        DialogFn.BlockUI();
        let nMuseum = formTicket.getValues("nMuseumID");
        let nYear = moment(formTicket.getValues("dTicket")).year();
        
        let param = {
            nYearTicket: nYear,
            nMuseumID: nMuseum
        }
        let sFileName = `รายงานสรุปรายละเอียดบัตรเข้าชม ประจำปี ${nYear + 543}.xlsx`
        AxiosFn.DowloadFileBlob(`ReportTicketFund/ExportTicketReport`, param, sFileName, (result) => {
            DialogFn.UnBlockUI();
        }, (error) => {
            DialogFn.Warning(error.sMessage)
            DialogFn.UnBlockUI()
        });
    }

    return (
            <FormProvider {...formTicket}>
                {/* รายงานตั๋ว */}
                <Typography style={{ fontSize: 18, fontWeight: 600, color: "#0056b3" }}>
                    {`${I18n.SetText("ReportParcel.sReportTicket")}`}
                </Typography>
                <Divider textAlign="left" style={{ fontSize: 18}}>{`${I18n.SetText("ReportParcel.sReportTicketSummary")}`}</Divider>
                <Stack direction={"row"} sx={{ mt: "2%", mb: "4%", mx: "4%" }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={3}>
                            <DatePickerItem
                                name={`dTicket`}
                                id={`dTicket`}
                                label={`${I18n.SetText("ReportParcel.sYear")}`}
                                IsYearPicker
                                required={true}
                                disabled={false}
                                fullWidth
                                maxDate={moment()}
                            />
                        </Grid>
                        <Grid item container xs={12} md={6}>
                            <SelectItem
                                id="nMuseumID"
                                name={"nMuseumID"}
                                label={"พิพิธภัณฑ์ (สังกัด)"}
                                placeholder={"พิพิธภัณฑ์ (สังกัด)"}
                                options={arrMuseum}
                                required={true}
                                disabled={!isPermission}
                            />
                        </Grid>
                        <Grid item>
                            <BtnExportExcel 
                                id={"export-ticket"}
                                onClick={formTicket.handleSubmit(handleExportExcelTicket)}
                            />
                        </Grid>
                    </Grid>
                </Stack>
            </FormProvider>
    );
}

export default ReportTicketFund